import { Button, Dialog, DialogActions, DialogContent, DialogHeader } from '@airbus/components-react';
import React from 'react';

type Props = {
    open: boolean;
    setOpen: (value: boolean) => void;
    title: string;
    buttons?: {
        close: string;
        validate: string;
    };
    onValidate: () => void;
};

const DialogInfo: React.FC<Props> = ({ open, setOpen, title, children, buttons, onValidate }) => {
    return (
        <React.Fragment>
            <Dialog open={open} onClose={() => setOpen(false)}>
                <DialogHeader>{title}</DialogHeader>
                <DialogContent>{children}</DialogContent>
                <DialogActions>
                    <Button variant="secondary" onClick={() => setOpen(false)}>
                        {buttons ? buttons.close : 'Cancel'}
                    </Button>
                    <Button variant="primary" onClick={() => onValidate()}>
                        {buttons ? buttons.validate : 'Validate'}
                    </Button>
                </DialogActions>
            </Dialog>
        </React.Fragment>
    );
};

export default DialogInfo;
